'use client';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import '@/styles/player-swiper.css';

import { useRouter } from 'next/navigation';
import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { publicEnv } from '@/lib/env';
import { CarouselNewsCard } from '@/modules/homepage/CarouselNewsCard/CarouselNewsCard';
import { SwiperNavButtons } from '@/modules/players/v2/tabs/overview/PlayerVideos';
import { ArticleTag } from '@/types/blog.types';

interface RelatedArticlesProps {
  relatedArticles: ArticleTag[];
}

export const RelatedArticles = ({ relatedArticles }: RelatedArticlesProps) => {
  const router = useRouter();
  return (
    <>
      <div className='mb-6 mt-16 text-2xl font-bold text-gray-900'>Related Content - Articles</div>
      <div className='mx-1 rounded-lg bg-white py-2 shadow-sm'>
        <div className='relative z-0 sm:hidden'>
          <Swiper
            pagination={{
              clickable: true,
              bulletActiveClass: 'custom-playerswiper-pagination-bullet-active',
            }}
            modules={[Pagination]}
            slidesPerView={1}
            loop
          >
            {relatedArticles.map((dataObj, index) => {
              const newsURL = `https://${publicEnv.NEXT_PUBLIC_HOME_ROOT_URL}/${dataObj.categorySlug}/${dataObj.slug}`;
              return (
                <SwiperSlide
                  key={`${dataObj.title}-mobile-${index}`}
                  className='mb-6 px-2 pt-2'
                  onClick={() => router.push(newsURL)}
                >
                  <CarouselNewsCard
                    url={newsURL}
                    image={dataObj.imageUrl}
                    imageAltText={dataObj.imageAltText}
                    title={dataObj.title}
                    publishDateDisplayed={dataObj.publishDateDisplayed}
                  />
                </SwiperSlide>
              );
            })}
            {relatedArticles.length > 1 && <SwiperNavButtons />}
          </Swiper>
        </div>
        <div className='relative hidden sm:block'>
          <Swiper
            pagination={{
              clickable: true,
              bulletActiveClass: 'custom-playerswiper-pagination-bullet-active',
            }}
            loop
            modules={[Pagination, Navigation]}
            slidesPerView={3}
            slidesPerGroup={3}
          >
            {relatedArticles.map((dataObj, index) => {
              const newsURL = `https://${publicEnv.NEXT_PUBLIC_HOME_ROOT_URL}/${dataObj.categorySlug}/${dataObj.slug}`;
              return (
                <SwiperSlide
                  key={`${dataObj.title}-${index}`}
                  className='mb-6 px-2 pt-2 hover:!cursor-pointer hover:rounded-lg hover:opacity-70'
                  onClick={() => router.push(newsURL)}
                >
                  <CarouselNewsCard
                    url={newsURL}
                    image={dataObj.imageUrl}
                    imageAltText={dataObj.imageAltText}
                    title={dataObj.title}
                    publishDateDisplayed={dataObj.publishDateDisplayed}
                  />
                </SwiperSlide>
              );
            })}
            {relatedArticles.length > 3 && <SwiperNavButtons />}
          </Swiper>
        </div>
      </div>
    </>
  );
};
